import React, { Component } from "react";
import { Modal } from "antd";
import { observer } from "mobx-react";
import { computed, observable, runInAction, toJS } from "mobx";
import { QUERY } from "../../utilities/network";
import { RouteComponentProps } from "react-router";
import { colours } from "../../utilities/styles";
import { Button } from "@material-ui/core";
import GroupOverviewTable from "../../components/groupOverviewTable";
import { FETCH_GROUP_IDS, GET_COMPARED_GROUPS } from "../../constants/requests";

@observer
export default class GroupOverview extends Component<RouteComponentProps<{}>> {
  @observable pageSize = 100;
  @observable keyword = "";
  @observable loading = false;
  @observable pagination = false;
  @observable groups: Array<ComparedGroupType> = [];
  filteredGroupIds: Array<number> = [];
  @computed
  get groupFilters() {
    return this.comparedGroups.map((group) => ({
      text: group.group_name,
      value: group.group_id,
    }));
  }

  _goToGroupDetail = (record: GroupType) => {
    this.props.history.push(`/admin/group-detail?id=${record.group_id}&name=${record.group_name}`);
  };

  @observable comparedGroups: Array<ComparedGroupType> = [];
  @computed
  get columns(): Array<any> {
    return [
      {
        title: "Group name",
        dataIndex: "group_name",
        key: "group_name",
        width: 150,
        filters: this.groupFilters,
        onFilter: (group_id: number, group: ComparedGroupType) => group.group_id === group_id,
      },
      {
        title: "Logged-in members",
        dataIndex: "group_active_members",
        key: "group_active_members",
        width: 100,
        align: "center",
      },
      {
        title: "Active last 30 days",
        dataIndex: "days30Ratio",
        key: "days30Ratio",
        width: 100,
        align: "center",
      },
      {
        title: "Avg activities /member",
        dataIndex: "group_average_sessions",
        key: "group_average_sessions",
        width: 100,
        align: "center",
      },
      {
        title: "Action",
        key: "action",
        render: (text: any, record: GroupType) => (
          <Button
            style={{ background: colours.yomento_purple, color: "#fff" }}
            onClick={() => this._goToGroupDetail(record)}
          >
            View group
          </Button>
        ),
        width: 100,
        align: "center",
      },
    ];
  }
  async componentDidMount() {
    await this._fetchComparedGroups();
  }

  render() {
    const pagination = this.keyword
      ? false
      : {
          pageSize: this.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
          onShowSizeChange: this._onPaginationSizeChange,
        };
    // @ts-ignore

    return (
      <GroupOverviewTable
        comparedGroups={this.comparedGroups}
        columns={this.columns}
        loading={this.loading}
        pagination={this.pagination}
        onTableChange={this._onTableChange}
        fetchComparedGroups={this._fetchComparedGroups}
      />
    );
  }

  _fetchComparedGroups = async () => {
    try {
      this.loading = true;

      const data = await QUERY<{ groups: Array<{ id: number }> }>(FETCH_GROUP_IDS);

      const groupIdsRef: Array<number> = data.groups.map((e) => e.id);
      const res = await QUERY<{ compare: Array<ComparedGroupType> }>(GET_COMPARED_GROUPS, {
        groupIds: groupIdsRef,
      });

      res.compare.forEach((group, index) => {
        group.key = index + 1;
        group.group_id = group.group_id;
        group.group_name = group.group_name;

        group.days30Ratio = group.group_active_members
          ? `${((group.active_30_days_users / group.group_active_members) * 100).toFixed()}%`
          : "";
        group.group_improvement_score = group.group_improvement_score
          ? `${group.group_improvement_score}%`
          : "--";
        group.ff_completed_user_percentage =
          typeof group.ff_completed_user_percentage === "number"
            ? `${group.ff_completed_user_percentage.toFixed()}%`
            : "--%";
      });

      runInAction(() => {
        this.comparedGroups = res.compare;
        this.loading = false;
      });
    } catch (e) {
      Modal.error({
        title: "Oops, something goes wrong.",
        content: e.message,
        okText: "GOT IT",
      });
    }
  };

  _onTableChange = async (
    pagination: { current?: any | number | boolean }, // when search with email keyword, there is no pagination on the page
    //filters: { group?: Array<number>; status?: Array<'Deactivated' | 'Not activated' | 'Active'> }
  ) => {
    const pageIndex = pagination.current ? pagination.current - 1 : 0;
    //this.filteredGroupIds = filters.group || [];
    // this.filteredStatus = filters.status || [];

    await this._fetchComparedGroups();
  };
  _onPaginationSizeChange = (current: number, size: number) => {
    this.pageSize = size;
  };
}

interface ComparedGroupType {
  key: number;
  group_ids: Array<number>;
  group_id: number;
  group_name: string;
  group_total_members: number;
  group_active_members: number;
  group_total_sessions: number;
  group_average_sessions: number;
  group_improvement_score: number | null | string;
  active_30_days_users: number;
  days30Ratio: number | string;
  feed_forward_trust_nps_avg: number | null | string;
  feed_forward_habit_index_avg: number | null | string;
  feed_forward_completed_percentage: number | string;
  ff_completed_user_percentage: number | string;
  ff_trust_nps_avg: number | null | string;
  ff_habit_index_avg: number | null | string;
}

export interface GroupType {
  key: number;
  group_id: number;
  group_name: string;
  description: string;
  country: string;
  created_at: string;
  total_number: number;
  activated_number: number;
}
